import { render, staticRenderFns } from "./IndustryManagement.vue?vue&type=template&id=18b568e6"
import script from "./IndustryManagement.vue?vue&type=script&lang=js"
export * from "./IndustryManagement.vue?vue&type=script&lang=js"
import style0 from "./IndustryManagement.vue?vue&type=style&index=0&id=18b568e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports